module.exports = __webpack_public_path__ + "static/media/29EUNOG2.4ac8c79f.jpg";